import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-lubes-guide-results]')) return;

  addEventListeners();
}

function addEventListeners() {
  lubesGuideResultsSetup();
  lubesGuideResultsDatalayer();
}

/**
 * function to setup for the lubes guide results
 * and adjust sticky position in case of header is present
 */
function lubesGuideResultsSetup() {
  const header = $('header');
  if (header) {
    $('[data-au-lubes-guide-results]').classList.add('au-lubes-guide-results--with-header');
  }
}

function lubesGuideResultsDatalayer() {
  $$('[data-au-lubes-guide-results] [data-au-collapsable]').forEach((collapsable) => {
    collapsable.addEventListener('click', (e) => {
      const target = e.target;
      const titleText = target.querySelector('[data-au-collapsable-title-text]').innerText;
      const model = target
        .closest('[data-au-lubes-guide-results]')
        .querySelector('[data-au-lubes-preview-result-card-title]').innerText;
      const category = target
        .closest('[data-au-lubes-guide-results-category]')
        .querySelector('[data-au-lubes-guide-results-category-title]').innerText;
      const action = target.getAttribute('aria-expanded') === 'false' ? 'contraer' : 'expandir';
      const item_id = `${removeAccentMarkAndUppercase(model)}_${removeAccentMarkAndUppercase(category)}_${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(action)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickBoton',
        item_id,
      });
    });
  });

  $$('[data-au-lubes-guide-results] [data-au-datalayer-product-card]').forEach((productCard) => {
    productCard.addEventListener('click', (e) => {
      const target = e.target;
      const model = target
        .closest('[data-au-lubes-guide-results]')
        .querySelector('[data-au-lubes-preview-result-card-title]').innerText;
      const titleCollapsable = target
        .closest('[data-au-collapsable-parent]')
        .querySelector('[data-au-collapsable-title-text]').innerText;
      const productTitle = target
        .closest('[data-au-product-card]')
        .querySelector('[data-au-product-card-title]').innerText;
      const item_id = `${removeAccentMarkAndUppercase(model)}_${removeAccentMarkAndUppercase(titleCollapsable)}_${removeAccentMarkAndUppercase(productTitle)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickCard',
        item_id,
      });
    });
  });

  $$('[data-au-lubes-guide-results] [data-au-datalayer-card-vertical]').forEach((productCard) => {
    productCard.addEventListener('click', (e) => {
      const target = e.target;
      const model = target
        .closest('[data-au-lubes-guide-results]')
        .querySelector('[data-au-lubes-preview-result-card-title]').innerText;
      const titleCollapsable = target
        .closest('[data-au-collapsable-parent]')
        .querySelector('[data-au-collapsable-title-text]').innerText;
      const productTitle = target
        .closest('[data-au-media-card-vertical]')
        .querySelector('[data-au-media-card-vertical-title]').innerText;
      const item_id = `${removeAccentMarkAndUppercase(model)}_${removeAccentMarkAndUppercase(titleCollapsable)}_${removeAccentMarkAndUppercase(productTitle)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickCard',
        item_id,
      });
    });
  });
}

export default { init };
